import axios from "axios";

const getAuthHeader = () => {
    const token = sessionStorage.getItem('token');
    const header = {
        headers: { 
            Authorization: "Bearer " + token
     }
    };
    return header;
}

export const getPayfortUrl =async(data)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/payfort`
    return axios.post(url,data,getAuthHeader()).then((res)=>{
        return res.data
    })
}